export const locale = {
  // id: 'en-CA',
  language: localStorage.getItem('locale') || 'en'
};
